import {Box, IconButton, Typography} from "@mui/material";
import {urls} from "../../../business/routes/urls";
import ListAltIcon from "@mui/icons-material/ListAlt";
import EqualizerIcon from "@mui/icons-material/Equalizer";
import ConfirmationCall from "@mui/icons-material/LocalPhone";
import StackedLineChartIcon from "@mui/icons-material/StackedLineChart";
import React from "react";
import {useNavigate} from "react-router-dom";
import {usePageTitle} from "../../../hooks/usePageTitle";

export const HeaderIconsSection = () => {

    const navigate = useNavigate();
    const {pageTitle} = usePageTitle();

    return (
        <Box sx={{display:'flex',alignItems:'center', width:'max-content'}}>
            <Typography variant="div" component="div" className="title_claims" fontWeight="600" width={'max-content'} mr={3}>
                {pageTitle}
            </Typography>
            <IconButton aria-label="List" onClick={() => navigate(urls.tasksList)}>
                <ListAltIcon />
            </IconButton>
            <IconButton aria-label="Graph" onClick={() => navigate(urls.tasksGraph)}>
                <EqualizerIcon />
            </IconButton>
            <IconButton aria-label="ConfirmationCalls" onClick={() => navigate(urls.confirmationCalls)}>
                <ConfirmationCall />
            </IconButton>
            {/*<IconButton aria-label="Statistics" onClick={() => navigate(urls.statistics)}>*/}
            {/*    <StackedLineChartIcon />*/}
            {/*</IconButton>*/}
        </Box>
    )
}